<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="component-chat-log" class="m-8 vs-con-loading__container">
		<div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">
			<div v-if="!msg.is_deleted_for_me">
				<!-- If previous msg is older than current time -->
				<template v-if="index > 0 && !isSameDay(msg.time_stamp, chatData[index - 1].time_stamp)">
					<vs-divider class="msg-time">
						<span>{{ toDate(msg.time_stamp) }}</span>
					</vs-divider>
					<div class="spacer mt-8"></div>
				</template>
				<div class="flex items-start" :class="[{'flex-row-reverse': msg.sender === userInfoId}]">
					<template v-if="isGroupChatRoom && msg.sender !== userInfoId">
						<vs-avatar
							size="40px"
							class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
							:class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
							:src="contactImage(msg.sender) ? contactImage(msg.sender).img : null"
							:title="contact(msg.sender) ? contact(msg.sender).username : ''"
						></vs-avatar>
					</template>
					<div
						class="msg break-words relative shadow-md rounded px-2 mb-2 rounded-lg max-w-sm"
						:class="{
							'bg-primary text-white': msg.sender === userInfoId,
							'border border-solid border-transparent bg-white': msg.sender !== userInfoId,
						}"
					>
						<div class="flex flex-wrap items-center">
							<vs-row v-if="!multimediaMessage(msg.text)" vs-w="12">
								<vs-col vs-w="12">
									<span>{{ msg.text }} </span>
								</vs-col>
							</vs-row>
							<img
								v-else
								:src="multimediaMessage(msg.text)"
								:alt="msg.text"
								class="responsive"
								:title="msg.text"
							/>
						</div>
						<div class="flex justify-end">
							<small
								v-if="index > 0 && getTime(msg.time_stamp) !== getTime(chatData[index - 1].time_stamp)"
								style="font-size: 10px"
								class="font-light"
								:style="{color: msg.sender === userInfoId ? '#ccc' : '#000'}"
								>{{ getTime(msg.time_stamp) }}</small
							>
							<i
								v-if="msg.sender === userInfoId"
								style="font-size: 16px"
								class="material-icons inline-block ml-2"
								:class="{'text-info': msg.is_seen}"
							>
								{{ msg.is_seen ? "done_all" : "done_all" }}
							</i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		chatKey: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			divider: [],
			bg: require("@/assets/images/pages/datarutas/1-02.png"),
			logo: require("@/assets/images/pages/datarutas/1-03.png"),
		};
	},
	computed: {
		chat() {
			return this.$store.getters["chat/chatDataOfUser"](this.chatKey);
		},
		chatData() {
			return this.chat && Object.hasOwn(this.chat, "messages")
				? Object.values(this.chat.messages).sort((a, b) => a.time_stamp - b.time_stamp)
				: [];
		},
		userInfoId() {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			return userInfo.datarutas_id;
		},
		isGroupChatRoom() {
			return Object.hasOwn(this.chat, "admin");
		},
		contactImage() {
			return function (id) {
				return this.$store.getters["chat/contactImg"](+id);
			};
		},
		contact() {
			return function (id) {
				return this.$store.getters["chat/contact"](+id);
			};
		},
		getTime() {
			return function (time) {
				const date_obj = new Date(+time);
				const newformat = date_obj.getHours() >= 12 ? "p.m." : "a.m.";
				const minutes = date_obj.getMinutes() < 10 ? "0" + date_obj.getMinutes() : date_obj.getMinutes();
				return `${date_obj.getHours()}:${minutes} ${newformat}`;
			};
		},
		multimediaMessage() {
			return function (message) {
				try {
					const url = new URL(message.trim());
					const urlExtension = url.pathname.split(".").slice(-1)[0];
					return urlExtension === "gif" ||
						urlExtension === "jpg" ||
						urlExtension === "png" ||
						urlExtension === "jpeg"
						? url.href
						: false;
				} catch (error) {
					return false;
				}
			};
		},
	},
	methods: {
		isSameDay(time_to, time_from) {
			const date_time_to = new Date(+time_to);
			const date_time_from = new Date(+time_from);
			const result =
				date_time_to.getFullYear() === date_time_from.getFullYear() &&
				date_time_to.getMonth() === date_time_from.getMonth() &&
				date_time_to.getDate() === date_time_from.getDate();

			return result;
		},
		toDate(time) {
			const locale = "es-co";
			const date_obj = new Date(+time);
			const monthName = date_obj.toLocaleString(locale, {
				month: "short",
			});
			return `${date_obj.getDate()} ${monthName}`;
		},
		toDateDay(time) {
			const date_obj = new Date(+time);
			return date_obj.getDate();
		},
		scrollToBottom() {
			this.$nextTick(() => {
				this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
			});
		},
	},
	updated() {
		this.scrollToBottom();
		if (this.isGroupChatRoom) {
			this.$store.dispatch("chat/markSeenAllGroupMessages", this.chat);
		} else {
			this.$store.dispatch("chat/markSeenAllMessages", this.chat);
		}
	},
	mounted() {
		this.scrollToBottom();
	},
};
</script>

<style scoped>
.responsive {
	width: 100%;
	height: auto;
}
</style>
